import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthorizeApi } from "./authorize-api";
import { map } from "rxjs/operators";
import { isPlainObject, isNil, isString } from "lodash";

@Injectable({
  providedIn: "root",
})
export class AuthorizeGuard implements CanActivate {
  constructor(private readonly api: AuthorizeApi, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.api.getConnectedUser().pipe(
      map((user) => {
        if (isNil(user) || !isPlainObject(user)) {
          this.router.navigate(["login"]);
          return false;
        }

        this.api.connectedUser$.next(user);
        return true;
      })
    );
  }
}
